<div
  mat-dialog-title
  style="display: flex; align-items: center; flex-wrap: wrap"
>
  <div style="font-size: 20px; font-weight: bold">{{ titulo }}</div>

  <!-- Mostrar información de gestiones cuando es por tipo -->
  <div *ngIf="esPorTipoEvento" style="width: 100%; margin-top: 10px">
    <span style="font-size: 14px; color: #666">
      <strong>Total gestiones:</strong> {{ totalGestiones }} |
      <strong>Gestiones:</strong> {{ numeroGestiones.join(", ") }}
    </span>
  </div>

  <!-- Mostrar número de gestión cuando es individual -->
  <div
    *ngIf="!esPorTipoEvento && data.gestionSelected"
    style="width: 100%; margin-top: 10px"
  >
    <span style="font-size: 14px; color: #666">
      <strong>Gestión:</strong> {{ data.gestionSelected.NumeroGestion }} |
      <strong>Cliente:</strong> {{ data.gestionSelected.Ruta?.ClienteNombre }}
    </span>
  </div>

  <button
    mat-button
    mat-dialog-close
    class="close-button"
    style="margin-left: auto"
  >
    <img
      src="../../../assets/icons/cerrar.png"
      alt="Cerrar"
      style="height: 30px; width: 30px"
    />
  </button>
</div>

<mat-dialog-content
  class="mat-typography"
  style="height: 91%; max-height: 91% !important"
>
  <!-- Mostrar contadores -->
  <div style="margin-bottom: 15px">
    <span style="font-size: 14px">
      <strong>Total eventos:</strong>
      {{ esPorTipoEvento ? data.totalEventos : data.listEventos?.length }} |
      <strong>Abiertos:</strong>
      {{
        esPorTipoEvento
          ? data.eventosAbiertos
          : data.listEventosAbiertos?.length
      }}
      | <strong>Cerrados:</strong>
      {{
        esPorTipoEvento
          ? data.eventosCerrados
          : data.listEventosCerrados?.length
      }}
    </span>
  </div>

  <!-- ************ Eventos Abiertos ************ -->
  <h2 style="font-size: 18px; font-weight: bold; margin-bottom: 10px">
    Eventos Abiertos
  </h2>

  <!--************Encabezado con columna adicional para gestión***********-->
  <div
    class="flexRowNoWrap EncabezadoGridR1"
    style="
      justify-content: space-between;
      flex-wrap: nowrap;
      min-height: 36px;
      min-width: 1720px;
    "
  >
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Gestión</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Fecha</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Sitio</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div
        class="cellListE1"
        style="display: unset; width: 280px; min-width: 280px"
      >
        <span>Categoria Evento</span>
      </div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Tipo</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Inicio</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Fin</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Usuario</span></div>
    </div>
  </div>

  <!--************Body grids***********-->
  <div
    style="height: 84%; min-width: 1720px; overflow-y: auto; overflow-x: hidden"
  >
    <!-- Usar datos diferentes según el caso -->
    <div
      *ngFor="
        let evento of esPorTipoEvento
          ? data.listEventosAbiertos
          : data.listEventosAbiertos
      "
      style="display: flex; justify-content: space-between; min-height: 36px"
      class="flexRowNoWrap rowGrid"
    >
      <!-- Columna de gestión -->
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{
            evento.NumeroGestion || data.gestionSelected?.NumeroGestion
          }}</span>
        </div>
      </div>

      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{
            evento.CreatedDate || formatFecha(evento.CreatedDate)
          }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.SitioNombre }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.DisplayName }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.Tipo }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.Inicio || formatFecha(evento.Inicio) }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.Fin || formatFecha(evento.Fin) }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.CreatedByNombre }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ************ Eventos Cerrados ************ -->
  <h2
    style="
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
      margin-top: 30px;
    "
  >
    Eventos Cerrados
  </h2>

  <!--************Encabezado con columna adicional para gestión***********-->
  <div
    class="flexRowNoWrap EncabezadoGridR1"
    style="
      justify-content: space-between;
      flex-wrap: nowrap;
      min-height: 36px;
      min-width: 1720px;
    "
  >
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Gestión</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Fecha</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Sitio</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div
        class="cellListE1"
        style="display: unset; width: 280px; min-width: 280px"
      >
        <span>Categoria Evento</span>
      </div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Tipo</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Inicio</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Fin</span></div>
    </div>
    <div style="min-width: 130px" class="cellListP">
      <div class="cellListE1"><span>Usuario</span></div>
    </div>
  </div>

  <!--************Body grids***********-->
  <div
    style="
      height: 84%;
      min-width: 1720px;
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 20px;
    "
  >
    <div
      *ngFor="
        let evento of esPorTipoEvento
          ? data.listEventosCerrados
          : data.listEventosCerrados
      "
      style="display: flex; justify-content: space-between; min-height: 36px"
      class="flexRowNoWrap rowGrid"
    >
      <!-- Columna de gestión -->
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{
            evento.NumeroGestion || data.gestionSelected?.NumeroGestion
          }}</span>
        </div>
      </div>

      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{
            evento.CreatedDate || formatFecha(evento.CreatedDate)
          }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.SitioNombre }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.DisplayName }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.Tipo }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.Inicio || formatFecha(evento.Inicio) }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.Fin || formatFecha(evento.Fin) }}</span>
        </div>
      </div>
      <div style="min-width: 130px" class="cellListP">
        <div class="cellListE1">
          <span>{{ evento.CreatedByNombre }}</span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    mat-dialog-close
    style="background-color: #f44336; color: white"
  >
    Cerrar
  </button>
</mat-dialog-actions>
